export const stripMarkdownForTTS = (text: string) => {
  return text
    .replace(/\*\*(.*?)\*\*/g, '$1') // Remove bold **
    .replace(/\*(.*?)\*/g, '$1')    // Remove italic *
    .replace(/#+\s?(.*)/g, '$1')     // Remove headers #
    .replace(/\[(.*?)\]\(.*?\)/g, '$1') // Remove links, keep text
    .replace(/[`]{1,3}(.*?)[`]{1,3}/g, '$1') // Remove code backticks
    .replace(/[-*]\s+/g, '');        // Remove list bullets
};

// --- VOICE UTILITIES ---
export const speakResponse = (text: string) => {
      if (typeof window !== 'undefined' && window.speechSynthesis) {
        // Stop any current speech before starting new one
        window.speechSynthesis.cancel();
        const newText = stripMarkdownForTTS(text);
        const utterance = new SpeechSynthesisUtterance(newText);
        utterance.rate = 1.0;
        utterance.pitch = 1.0;
        window.speechSynthesis.speak(utterance);
      }
  };